export const urlParameterCodes = {
  productDetail: {
    chooserOpen: 'chooser',
    sku: 'sku',
    doorKnob: 'knob',
    bundleId: 'setId',
    bundleSkus: 'setSkus',
    serviceId: 'serviceId',
    subscription: 'subscription',
    upgrade: 'upgrade',
    notifyOutOfStock: 'notifyOos',
  },
  cart: 'cart',
  nuFlow: 'nuFlow',
  referralCode: 'refCode',
  localeSwitch: 'localeSwitch',
};
